import { Row } from '@types'

/** Сплющенные значения формы: {id, label} → id, пустые строки отфильтрованы (как currentRowValues в ActionButton) */
export const flattenFieldValues = (fieldsArray: Row): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(fieldsArray)
      .map(([key, value]) => [
        key,
        value && typeof value === 'object' && 'id' in (value as Record<string, unknown>)
          ? (value as { id?: unknown }).id
          : value,
      ])
      .filter(([_, value]) => value !== '')
  )
